
import {createSlice} from "@reduxjs/toolkit";

export const platformSlice = createSlice({
    name: 'platformSlc',
    initialState: {value: {id: null, externalId: null, mcode: null, name: null,
            service: null, territory: null, usageMarket: null, owner: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            platformDrawerState: false, platformDrawerMode: null, platformGridRefresh: false
        }},
    reducers:

{
    changePlatform: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changePlatform } = platformSlice.actions;

export default  platformSlice.reducer ;
